
import { Marker, Popup } from 'react-leaflet';
import useZoomLevel from './useZoomLevel'; 
import {iconDividerUpc, iconDividerApc } from '../Constants/ConstantsOptics';
import { SERVICE_HOUSE_URL } from '../OpticApiConfig';

const MarkersViewingDivider = ({ data, icon, layersVisibilityCommunications, isLineDrawing, flag,
  openModalWithContent, statusModalTerritory, highwayFlag, cantonFlag, type, user, cantonRefresh,
  highwayRefresh, isComponentChangeCoor, setIsComponentChangeCoor, showPonLayer, showKtvLayer, showEtherLayer}) => {

    const zoomLevel = useZoomLevel();
  
    return (
      <>
        
    {data.map((item, index) => {
     

      if (zoomLevel <= 16) {
        return null;
      }

    
      const shouldDisplayMarker =
      layersVisibilityCommunications &&
      (
        (showPonLayer && item.ponDivider === 1) || 
        (showKtvLayer && item.ktvDivider === 1) 
      
      );

      if (!shouldDisplayMarker) {
        return null;
      }

  return (
    <Marker
      key={index}
      position={[item.latitude, item.longitude]}
      icon={item.polishingId === 1 ? iconDividerUpc : item.polishingId === 2 ? iconDividerApc : icon}
     >
       {!isLineDrawing && (
          <Popup className="custom-popup">
             <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <img  src={item.polishingId === 1 ? './divider_upc2.png' : item.polishingId === 2 ? './divider_apc2.png' : './divider_upc2.png'}
                alt="Divider Icon"
                style={{ width: '32px', height: '32px' }} 
                />
              </div>
              <span style={{ fontWeight: 'bold', fontSize: '14px' }}>
              <a href={`${SERVICE_HOUSE_URL}?Id=${item.hid}`} target="_blank" style={{ fontWeight: 'bold', color: "#444444" }}>
                 {item.street}, дом. {item.house}
              </a>
              </span>
              <br />
                          
              <span style={{ color: '#616161', fontWeight: 'bold', fontSize: '14px' }}>
               Подъезд:
              <span style={{ color: 'black', fontWeight: 'normal' }}> {item.entrance}</span>
              </span>
              <hr className='horizontalLineFilter' />
              <span style={{ fontWeight: 'bold', fontSize: '14px' }}>Делитель:</span> {item.model} <br />
              <span style={{ fontWeight: 'bold', fontSize: '14px' }}>Признак:</span> 
                        <span style={{ fontSize: '12px' }}>
                          {item.ktvDivider === 1 && item.ponDivider === 1
                            ? ' KTV PON'
                            : item.ktvDivider === 1
                            ? ' KTV'
                            : item.ponDivider === 1
                            ? ' PON'
                            : ' нет'}
                        </span><br />
              <span style={{ fontWeight: 'bold', fontSize: '14px' }}>Коммент:</span> {item.description} <br />
          </Popup>
          )}
      </Marker>
  );
})}
</>
    );
  };
  
  export default MarkersViewingDivider;